"use client";

import Link from "next/link";
import { useActionState, useEffect, useRef } from "react";
import { TurnstileWidget } from "../turnstile-widget";
import { requestPasswordReset } from "./actions";

export function ForgotPasswordForm() {
  const [state, formAction, pending] = useActionState(requestPasswordReset, undefined);
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    if (state?.success) formRef.current?.reset();
  }, [state]);

  return (
    <form ref={formRef} action={formAction} className="space-y-5">
      <div>
        <label htmlFor="email" className="mb-1.5 block text-sm font-bold text-zinc-700">
          Email
        </label>
        <input
          id="email"
          name="email"
          type="email"
          required
          autoComplete="email"
          className="w-full rounded-xl border border-[#e0507a]/20 bg-white px-4 py-3 text-sm text-zinc-900 outline-none transition-colors placeholder:text-zinc-400 focus:border-[#e0507a] focus:ring-2 focus:ring-[#e0507a]/20"
        />
      </div>

      <TurnstileWidget />

      {state?.error && (
        <p className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700" role="alert">
          {state.error}
        </p>
      )}
      {state?.success && (
        <p
          className="rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-700"
          role="status"
        >
          {state.success}
        </p>
      )}

      <button
        type="submit"
        disabled={pending}
        className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#e8607a] px-8 py-3.5 text-sm font-bold uppercase tracking-widest text-white shadow-md transition-all hover:-translate-y-0.5 hover:bg-[#d4556e] disabled:pointer-events-none disabled:opacity-60"
      >
        {pending ? "Wysyłanie…" : "Wyślij link resetujący"}
      </button>

      <p className="text-center text-sm text-zinc-600">
        Wróć do{" "}
        <Link href="/login" className="font-bold text-[#e0507a] hover:text-[#c9436a]">
          logowania
        </Link>
      </p>
    </form>
  );
}
